import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export const isValidRecipient = recipient => isValidBase(recipient) && validateProps(recipient, ['metaSiteId']);
export const recipientApiToRecipientEntity = recipient => {
  if (!recipient) {
    throw new Error('recipient undefined', {
      cause: {
        recipient
      }
    });
  }
  const convertedRecipient = {
    id: recipient.id,
    revision: recipient.revision,
    createdDate: recipient.createdDate,
    updatedDate: recipient.updatedDate,
    name: recipient.name,
    email: recipient.email,
    phone: recipient.phone,
    metaSiteId: recipient.metaSiteId,
    activeWhatsappConversationId: recipient.activeWhatsappConversationId
  };
  if (isValidRecipient(convertedRecipient)) {
    return convertedRecipient;
  }
  throw new Error('Invalid recipient data', {
    cause: {
      recipient
    }
  });
};
export const recipientEntityToRecipientApi = recipient => ({
  id: recipient.id,
  revision: recipient.revision,
  createdDate: recipient.createdDate,
  updatedDate: recipient.updatedDate,
  name: recipient.name,
  email: recipient.email,
  phone: recipient.phone,
  metaSiteId: recipient.metaSiteId,
  activeWhatsappConversationId: recipient.activeWhatsappConversationId
});
//# sourceMappingURL=Recipient.js.map